import React from 'react';
import {gql} from "apollo-boost";
import client from '../../src/graphql/client';
import {get} from 'lodash';
import {Grid, Box} from '@material-ui/core';
import styled from 'styled-components';

import Icon from '../../src/assets/icons/speech-double-circle.svg';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../src/data-restructure/multimedia/hero-banner-carousel';
import {theme} from '../../src/themes/default-theme';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

// components
import FormContainer from '../../src/containers/Forms/FormContainer';
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';
import Disclaimer from '../../src/components/ui/Disclaimer';

const downSm = '@media (max-width: 939.95px)' // '@media (max-width: 839.95px)';
const upMd = '@media (min-width: 940px)' // '@media (min-width: 840px)';

const Wrapper = styled.div`
  ${upMd} {
    margin-top: 87px;
  }
`

const DisclaimerWrapper = styled.div`
  padding: 30px 0;
  background-color: ${theme.palette.lightGrey};
  text-align: center;
  ${theme.breakpoints.up('lg')} {
    padding: 55px 0;
  }
`

const FinanceEnquiry = (props) => {

  const country = props.countryProps.countryCode === 'AU' ? "Australia's" : "New Zealand's"
  const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"

  return (

    <Wrapper>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          largePaddingTop={true}
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }

      <FormContainer
        icon={Icon}
        formId="finance_enquiry"
        thankYouUrl="/finance-enquiry/thank-you"
        title="Talk to our finance experts today"
        text="Send us your contact details and our finance team will respond to your enquiry"
        formItems={[
          {
            type: 'name',
            name: 'first_name',
            label: 'first_name',
            placeholder: 'First name*',
            required: true,
            errorText: 'This field is required'
          },
          {
            type: 'name',
            name: 'last_name',
            label: 'last_name',
            placeholder: 'Last name*',
            required: true,
            errorText: 'This field is required'
          },
          {
            type: 'email',
            name: 'email',
            label: 'email',
            placeholder: 'Email*',
            required: true,
            errorText: 'Please add a valid email address'
          },
          {
            type: 'phone',
            name: 'phone',
            label: 'phone',
            placeholder: 'Contact Number*',
            required: true,
            errorText: 'Please add a valid phone number'
          },
          {
            type: 'postcode',
            name: 'postcode',
            label: 'postcode',
            placeholder: 'Postcode*',
            required: true,
            errorText: 'Please add a 4 digit postcode'
          },
          {
            type: 'textarea',
            name: 'comments',
            label: 'Your enquiry',
            placeholder: 'Your enquiry:*',
            rows: 5,
            required: true,
            errorText: 'This field is required'
          },
          {
            type: 'checkbox',
            margin: 'none',
            name: 'e_newsletter',
            label: `Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`,
          },
          {
            type: 'checkbox',
            margin: 'none',
            name: 'privacy',
            label: `I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy Policy</a>*`,
            required: true,
            errorText: 'This field is required'
          }
        ]}
      />
      <DisclaimerWrapper>
        <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="nowrap" justify={'center'}>
          <Grid item xs={12} lg={9}>
            <Box px={2}>
              <Disclaimer>
                <p>Jayco Financial services Pty Ltd Credit Representative number 513573 of My Local Broker PTY LTD (Australia Credit License no 481374) Finance will be supplied to approved applicants only (not available to fleet, government or rental buyers), subject to credit assessment and lending criteria. Fees and charges are payable. Full conditions available on application.</p>
              </Disclaimer>
            </Box>
          </Grid>
        </Grid>
      </DisclaimerWrapper>
    </Wrapper>
  )
}
  
FinanceEnquiry.propTypes = {

}
  
FinanceEnquiry.defaultProps = {

}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  
  const GET_CB_DATA = gql`
    query GET_CB_DATA {
      pageBy(uri: "finance-enquiry?${countryCode}") {
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery()}
        acf_domains {
          assignedDomains
        }
      }
    }
  `

  const result = await client.query({
    query: GET_CB_DATA,
  });

  const context = get(result, 'data.pageBy', {});
  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;

  // Banner carousel
  const hasCarousel = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(cbData[0]) : null;

  const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []); 

  return {
    props: {
      meta: {
        title: context.title,
        seo: context.seo,
        assignedDomains
      },
      breadcrumbs: await refactorBreadcrumbsData('/finance-enquiry', assignedDomains),
      heroBanner,
      heroBannerCarousel,
      marginTop: heroBanner ? false : true
    }
  }
}
  
export default FinanceEnquiry